"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function handleError(result, options) {
    const message = result.errors ? result.errors[0].message : '';
    const error = new Error(message);
    error.isApolloError = true;
    error.errors = result.errors;
    error.result = result;
    error.options = options;
    throw error;
}
exports.default = handleError;
